import { faSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, Typography } from '@material-ui/core';
import {
  endorsementCoverages,
  fullDataForCode,
} from 'data-layer-cr/dist/functions/coverages';
import { CoverageCatalog, QuotationCoverage } from 'data-layer-cr/dist/models';
import { moneyFormat } from 'design-system';
import { useMemo } from 'react';
import { AssaMobile } from 'src/components/screens/Quotations/components';
import FreeMonthCard from 'src/components/screens/Quotations/components/FreeMonthCard';
import PricingProfileResponse from 'src/models/responseTypes/PricingProfileResponse';
import BenefitRow from './BenefitRow';

const { formatMoney } = moneyFormat;

type EndorsementDetail = {
  code: string;
  name: string;
  value: string;
};

type Props = {
  isPremiumOption?: boolean;
  currency: string;
  packageCoverages: QuotationCoverage[];
  coverageCatalogs: CoverageCatalog[];
  currentProfile: PricingProfileResponse;
  iconCheck?: boolean;
};

const IndividualBenefits = ({
  currency,
  coverageCatalogs,
  packageCoverages,
  currentProfile,
  iconCheck,
}: Props): JSX.Element => {
  const endorsementResume = useMemo((): EndorsementDetail[] => {
    const resume: EndorsementDetail[] = [];
    const endorsementCoverageList = endorsementCoverages(coverageCatalogs);
    packageCoverages.forEach((coverage) => {
      const endorsement = fullDataForCode(
        endorsementCoverageList,
        coverage.coverageId,
      );
      if (endorsement) {
        resume.push({
          code: endorsement.code,
          name: endorsement.name.toLowerCase(),
          value: formatMoney(endorsement.maxCost, false, currency),
        });
      }
    });
    return resume;
  }, [coverageCatalogs, packageCoverages, currency]);
  return (
    <Box data-testid="individual-benefits-resume-card">
      <Grid container>
        <FontAwesomeIcon icon={faSparkles} size="2xl" color="#0D2E68" />
        <Typography data-testid="title-text">
          Beneficios de la póliza
        </Typography>
      </Grid>
      <AssaMobile data-testid="assa-mobile-logo" />
      {['RetencionBacCRC', 'RetencionBacUSD'].includes(
        currentProfile.productId,
      ) && <FreeMonthCard data-testid="assa-card-logo" />}

      {endorsementResume.map(({ code, name, value }) => (
        <BenefitRow
          key={code}
          data-testid={`endorsement-${code}`}
          name={name}
          value={value}
          iconCheck={iconCheck}
        />
      ))}
    </Box>
  );
};

export default IndividualBenefits;
